const routesPath = {
  ALL: '*',
  DEFAULT: '/',
  LOGIN: '/login',
  DEALS: '/deals',
  COMPANY: '/companies',
  CREATE_DEAL: '/deals/create',
  CREATE_COMPANY: '/companies/create',
  EDIT_DEAL: '/deals/edit',
  SYNDICATE: '/syndicate',
  CREATE_SYNDICATE: '/syndicate/create',
  DEAL_INVITE: '/deals/invite',
  SYNDICATE_INVITE: '/syndicate/invite',
  EDIT_SYNDICATE: '/syndicate/edit',
  USER: '/users',
  VIEW_USER: '/users/details',
  APP_INVITE: '/users/app-invite',
  VERIFY_USER: '/verify',
  UPDATE_VERIFY: '/verify/update',
  DEAL_ANALYTICS: '/deals/analytics',
  OPPORTUNITIES: '/opportunities',
  CREATE_WISHLIST: '/opportunities/wishlist/create',
  EDIT_WISHLIST: '/opportunities/wishlist/edit',
  VIEW_WISHLIST: '/opportunities/wishlist/view',
  CREATE_EARLY_ACCESS: '/opportunities/early-accCREATE_PRE_IPO_DEALess/create',
  EDIT_EARLY_ACCESS: '/opportunities/early-access/edit',
  VIEW_EARLY_ACCESS: '/opportunities/early-access/view',
  SCREENING: '/screening',
  VIEW_OVERALL_SUBSCRIPTION_STATUS: '/overall-subscription-status',
  VIEW_OVERALL_WISHLISTED_USERS: '/overall-wishlisted-status',
  TRANSACTIONS: '/transactions',
  PRE_IPO_DEALS: '/pre-ipo-deals',
  PRE_IPO_ENQUIRES: '/pre-ipo-enquires',
  CREATE_PRE_IPO_DEAL: '/pre-ipo-deals/create',
  EDIT_PRE_IPO_DEAL: '/pre-ipo-deals/edit',
  UPDATE_PRE_IPO_SHARE_PRICE: '/pre-ipo-deals/update-share-price',
  DEAL_ENQUIRES: '/deal-enquires'
};

export default routesPath;
